/* SENSE5 2.0 core — GSAP loader + robuste Reveals (fail-open, IntersectionObserver) */
(function () {
  if (window.S5V2_CORE) return; window.S5V2_CORE = true;
  var root = document.documentElement;
  var Q = [];
  window.s5v2Reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Animationsschicht nur aktivieren, wenn Bewegung erwünscht ist.
  // Ohne diese Klasse bleibt sämtlicher Inhalt über CSS sichtbar (fail-open).
  if (!window.s5v2Reduced) root.classList.add('s5v2-anim');

  window.s5v2Ready = function (fn) { if (window.S5V2_GSAP) fn(); else Q.push(fn); };

  /* ---- Reveal per IntersectionObserver (unabhängig von GSAP/Scroll-Scrub) ---- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }) : null;

  window.s5v2Reveal = function (trigger, els) {
    var list = (els && els.length !== undefined) ? Array.prototype.slice.call(els) : [els];
    list.forEach(function (el, i) {
      if (!el || el.nodeType !== 1) return;
      el.classList.add('s5v2-r');
      el.style.transitionDelay = (i * 90) + 'ms';
      if (window.s5v2Reduced || !io || !root.classList.contains('s5v2-anim')) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  };

  function revealAllR() { document.querySelectorAll('.s5v2-r').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---- Sicherheitsnetz für GSAP-versteckte Inhalte (scrub-Reveals), die in
     In-App-Webviews evtl. nie animiert werden: sobald sie in den Viewport
     kommen und noch unsichtbar sind, werden sie freigegeben. Auf dem Desktop
     sind sie zu diesem Zeitpunkt bereits per ScrollTrigger sichtbar -> no-op. --- */
  function armGsapNet() {
    if (!('IntersectionObserver' in window)) return;
    var net = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var op = parseFloat(getComputedStyle(el).opacity);
        if (isNaN(op) || op < 0.05) {
          try { gsap.set(el, { clearProps: 'opacity,visibility,transform' }); }
          catch (x) { el.style.opacity = '1'; el.style.visibility = 'visible'; el.style.transform = 'none'; }
        }
        net.unobserve(el);
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.s5v2 h1,.s5v2 h2,.s5v2 h3,.s5v2 p,.s5v2 .s5v2-btn,.s5v2 .bottle,.s5v2 .trio,.s5v2 .world,.s5v2 .band,.s5v2 blockquote,.s5v2 figcaption')
      .forEach(function (el) { if (el && el.nodeType === 1) net.observe(el); });
  }

  function loaded() {
    window.S5V2_GSAP = true;
    try { gsap.registerPlugin(ScrollTrigger); } catch (e) {}
    Q.forEach(function (f) { try { f(); } catch (e) { console.warn('s5v2', e); } });
    Q = [];
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () { try { ScrollTrigger.refresh(); } catch (e) {} });
    }
    window.addEventListener('resize', function () { try { ScrollTrigger.refresh(); } catch (e) {} });
    // Mobile-Webviews vermessen die Viewport-Höhe verzögert -> mehrfach refreshen.
    [300, 1000, 2400].forEach(function (t) { setTimeout(function () { try { ScrollTrigger.refresh(); } catch (e) {} }, t); });
    setTimeout(armGsapNet, 1600);
  }

  function fail() { // GSAP nicht ladbar -> keine Animationen, aber alles sichtbar
    if (window.S5V2_GSAP) return;
    root.classList.remove('s5v2-anim');
    revealAllR();
    Q = [];
  }

  function load(src, cb, onerr) {
    var s = document.createElement('script'); s.src = src; s.onload = cb; s.onerror = onerr; document.head.appendChild(s);
  }

  if (window.gsap && window.ScrollTrigger) { loaded(); }
  else {
    var done = false;
    var guard = setTimeout(function () { if (!done && !window.S5V2_GSAP) { done = true; fail(); } }, 4000);
    load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', function () {
      load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js',
        function () { if (done) return; done = true; clearTimeout(guard); loaded(); },
        function () { if (done) return; done = true; clearTimeout(guard); fail(); });
    }, function () { if (done) return; done = true; clearTimeout(guard); fail(); });
  }

  window.s5v2InitBreath = function (br) {
    if (!br || br.dataset.booted) return; br.dataset.booted = '1';
    var phases = (br.dataset.phases || 'Einatmen:4,Halten:4,Ausatmen:4').split(',').map(function (p) {
      var kv = p.split(':'); return { label: kv[0].trim(), secs: parseFloat(kv[1] || 4) || 4 };
    });
    var phaseEl = br.querySelector('.s5v2-breath__phase');
    var inner = br.querySelector('.s5v2-breath__box i');
    var cnt = br.querySelector('.s5v2-breath__box b');
    if (window.s5v2Reduced) { if (cnt) cnt.textContent = ''; if (phaseEl) phaseEl.textContent = phases[0].label; return; }
    window.s5v2Ready(function () {
      var tl = gsap.timeline({ repeat: -1 });
      phases.forEach(function (ph) {
        tl.call(function () { phaseEl.textContent = ph.label; });
        if (/^ein/i.test(ph.label)) tl.to(inner, { scale: 1.55, duration: ph.secs, ease: 'sine.inOut' });
        else if (/aus/i.test(ph.label)) tl.to(inner, { scale: 1, duration: ph.secs, ease: 'sine.inOut' });
        else tl.to({}, { duration: ph.secs });
        (function (secs) {
          var o = { v: secs };
          tl.to(o, { v: .01, duration: secs, ease: 'none',
            onUpdate: function () { if (cnt) cnt.textContent = Math.ceil(o.v); } }, '<');
        })(ph.secs);
      });
    });
  };
})();
